import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Select, Input, Typography, Tag } from 'antd';
import { DeleteOutlined, CalendarOutlined } from '@ant-design/icons';

import { AddsContainer } from './common';
import WorkOrderDetailsContext from '../../../containers/WorkOrder/WorkOrderDetailsContext';

import IssueObject, {
  getPriorityTagColor,
  getPriorityTagDescription,
} from 'stores/Classes/IssueObject';
import { getNextPMColor } from 'shared/pms';

const { Option } = Select;
const { Text } = Typography;

const IconCol = styled(Col)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function PM({
  itemKey,
  allPMs,
  PMs,
  deleteSubItem,
  changeSubItem,
  changeItemProperty,
}) {
  const formatLabel = (pm) => {
    return (
      <>
        <Tag color="blue" style={{ lineHeight: '16px' }}>
          PM
        </Tag>
        <Text
          style={{ color: getNextPMColor(pm.active_pm_status, false, false) }}
        >{`${Math.max(0, Math.floor(pm.active_pm_percent))}% ${
          pm.active_pm_status
        }`}</Text>{' '}
        - <Text>{pm.action}</Text>
      </>
    );
  };

  const handleChange = (value) => {
    const ids = value.map(String); //value.includes(',') ? value.split(',') : [value]; // Normalize to array
    const pms = PMs.filter((d) => ids.includes(String(d.id))).map((pm) => {
      return {
        id_pm: pm.id,
        name: pm.name,
      };
    });

    changeItemProperty(itemKey, 'pms', pms);
  };

  const validPMs = allPMs.filter((d) => d.id_pm);

  return (
    <AddsContainer>
      <Row type="flex" align="middle">
        <Col style={{ width: 40, textAlign: 'center' }}>
          <CalendarOutlined style={{ fontSize: '32px' }} />
        </Col>
        <Col style={{ flex: 1, paddingLeft: 5 }}>
          <Row>
            <Col span={23} style={{ borderBottom: '1px solid #d9d9d9' }}>
              Service
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row style={{ marginTop: '10px' }}>
            <Col span={23}>
              <Select
                style={{ width: '100%' }}
                onChange={handleChange}
                mode="multiple"
                {...(validPMs.length > 0 && {
                  value: validPMs.map((d) => d.id_pm),
                })}
              >
                {PMs.map((pm, index) => {
                  return (
                    <Option key={pm.id} value={pm.id}>
                      {formatLabel(pm)}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <IconCol span={1}>
              <DeleteOutlined
                style={{ fontSize: '20px', color: 'red' }}
                onClick={deleteSubItem}
              />
            </IconCol>
          </Row>
        </Col>
      </Row>
    </AddsContainer>
  );
}

export default PM;
